// Attio API endpoints
// Workboard
export const retrieveTeamRecord = '/api/attio/objects/team/records/query';
export const retrieveValuationList = '/api/attio/objects/valuations/records/query';
export const retrieveNotesByRecordIdAndParentObject = (parentRecordId: string, parentObject: string) =>
  `/api/attio/notes?parent_record_id=${parentRecordId}&parent_object=${parentObject}`;
export const retrieveBulkNotes = '/api/analyst-notes/bulk/';

// Operations
export const retrieveValuationByRecordId = (valuationRecordId: string) =>
  `/api/attio/objects/valuations/records/${valuationRecordId}`;
export const updateValuationByRecordId = (valuationRecordId: string) =>
  `/api/attio/objects/valuations/records/${valuationRecordId}`;
export const retrieveEntityRecordId = (targetRecordId: string) =>
  `/api/attio/objects/companies/records/${targetRecordId}`;
export const retrieveTeamByRecordId = (targetRecordId: string) => `/api/attio/objects/team/records/${targetRecordId}`;
export const retrievePeopleByRecordId = (targetRecordId: string) =>
  `/api/attio/objects/people/records/${targetRecordId}`;
export const retrieveDealByRecordId = (targetRecordId: string) => `/api/attio/objects/deals/records/${targetRecordId}`;
export const retrieveWorkspaceMemberByRecordId = (targetRecordId: string) =>
  `/api/attio/workspace_members/${targetRecordId}`;
export const retrieveStatusOptions = (objectId: string, attributeId: string) =>
  `/api/attio/objects/${objectId}/attributes/${attributeId}/options`;
export const retrieveDealContractByRecordId = (listIdOrSlug: string) => `/api/attio/lists/${listIdOrSlug}/entries/query`
// Analyst notes endpoints
export const retrieveUserNoteByValuationId = (attioValuationId: string) =>
  `/api/analyst-notes/${attioValuationId}/`;

export const retrieveDealStatuses = () => '/api/attio/objects/deals/attributes/stage/statuses';

export const updateValuationDealStage = (attioValuationId: string) =>
  `/api/attio/objects/deals/records/${attioValuationId}`;

export const createAnalystNote = () => '/api/analyst-notes/';

export const updateAnalystNote = (attioValuationId: string) =>
  `/api/analyst-notes/${attioValuationId}/`;

export const searchTeamMembers = () =>
  '/api/attio/objects/team/records/query';

export default {
  retrieveTeamRecord,
  retrieveValuationList,
  retrieveBulkNotes,
  retrieveNotesByRecordIdAndParentObject,
  retrieveValuationByRecordId,
  updateValuationByRecordId,
  retrieveEntityRecordId,
  retrieveTeamByRecordId,
  retrievePeopleByRecordId,
  retrieveDealByRecordId,
  retrieveWorkspaceMemberByRecordId,
  retrieveStatusOptions,
  retrieveUserNoteByValuationId,
  createAnalystNote,
  updateAnalystNote,
  retrieveDealContractByRecordId,
  retrieveDealStatuses,
  updateValuationDealStage,
  searchTeamMembers,
};
